import { StepProps } from 'antd'

import { BaseOption, Country } from 'shared/types/types'

import { Citizenship, CompanyType, CountryItem, DocumentType, GENDER, TaxCheckStatusType } from './types'

export const taxCheckStatusName = {
  [TaxCheckStatusType.review]: 'Документы по обновлению ставки налогообложения находятся на проверке',
  [TaxCheckStatusType.success]: 'Ставка налогообложения обновлена',
  [TaxCheckStatusType.remark]: 'Документы не подтверждены. Необходимо внести актуальные данные',
  [TaxCheckStatusType.canceled]: 'Документы не подтверждены. Необходимо внести актуальные данные',
}

export const STEPS_TITLES: StepProps[] = [
  { title: 'Форма деятельности' },
  { title: 'Персональные данные' },
  { title: 'Прикрепление фотографий удостоверения личности' },
  { title: 'Контактная информация' },
]

export const countriesWithMultipleDocuments = [
  Citizenship.AM,
  Citizenship.KG,
  Citizenship.KZ,
  Citizenship.UZ,
  Citizenship.BY,
]

export const countriesAuth: BaseOption<CountryItem>[] = [
  { label: 'Россия', value: { label: 'Россия', value: '7', country: Country.RU } },
  { label: 'Казахстан', value: { label: 'Казахстан', value: '7', country: Country.KZ } },
  { label: 'Армения', value: { label: 'Армения', value: '374', country: Country.AM } },
  { label: 'Беларусь', value: { label: 'Беларусь', value: '375', country: Country.BY } },
  { label: 'Узбекистан', value: { label: 'Узбекистан', value: '998', country: Country.UZ } },
  { label: 'Кыргызстан', value: { label: 'Кыргызстан', value: '996', country: Country.KG } },
  { label: 'Грузия', value: { label: 'Грузия', value: '995', country: Country.GE } },
  { label: 'Таджикистан', value: { label: 'Таджикистан', value: '992', country: Country.TJ } },
  { label: 'Туркменистан', value: { label: 'Туркменистан', value: '993', country: Country.TM } },
]

export const countries: BaseOption<CountryItem>[] = [
  { label: 'Россия', value: { label: 'Россия', value: '7', country: Country.RU } },
  { label: 'Казахстан', value: { label: 'Казахстан', value: '7', country: Country.KZ } },
  { label: 'Армения', value: { label: 'Армения', value: '374', country: Country.AM } },
  { label: 'Беларусь', value: { label: 'Беларусь', value: '375', country: Country.BY } },
  { label: 'Узбекистан', value: { label: 'Узбекистан', value: '998', country: Country.UZ } },
  { label: 'Кыргызстан', value: { label: 'Кыргызстан', value: '996', country: Country.KG } },
  { label: 'Грузия', value: { label: 'Грузия', value: '995', country: Country.GE } },
  { label: 'Таджикистан', value: { label: 'Таджикистан', value: '992', country: Country.TJ } },
]

export const citizenshipOptions = [
  { label: 'Россия', value: Citizenship.RU },
  { label: 'Казахстан', value: Citizenship.KZ },
  { label: 'Армения', value: Citizenship.AM },
  { label: 'Беларусь', value: Citizenship.BY },
  { label: 'Узбекистан', value: Citizenship.UZ },
  { label: 'Кыргызстан', value: Citizenship.KG },
  { label: 'Грузия', value: Citizenship.GE },
  { label: 'Таджикистан', value: Citizenship.TJ },
]

export const documentsTypeOptions = [
  { label: 'Паспорт', value: DocumentType.passport },
  { label: 'Идентификационная карта', value: DocumentType.identification },
]

export const identificationCardLabels = {
  [Citizenship.AM]: 'Идентификационная карта/ID card',
  [Citizenship.KG]: 'Идентификационная карта',
  [Citizenship.KZ]: 'Удостоверение личности',
  [Citizenship.UZ]: 'Идентификационная карта',
  [Citizenship.BY]: 'Идентификационная карта',
  [Citizenship.GE]: 'Идентификационная карта',
  [Citizenship.TJ]: 'Идентификационная карта',
  [Citizenship.RU]: 'Идентификационная карта',
}

export const companyNameWithCompanyType = {
  [Country.RU]: [
    ['ИП', CompanyType.ip],
    ['ООО', CompanyType.ooo],
  ],

  [Country.AM]: [
    ['ИП', CompanyType.ip],
    ['ООО', CompanyType.ooo],
  ],

  [Country.KZ]: [
    ['ИП', CompanyType.ip],
    ['ООО', CompanyType.ooo],
  ],

  [Country.BY]: [
    ['ИП', CompanyType.ip],
    ['ООО', CompanyType.ooo],
  ],

  [Country.UZ]: [
    ['ИП', CompanyType.ip],
    ['ООО', CompanyType.ooo],
  ],

  [Country.KG]: [
    ['ИП', CompanyType.ip],
    ['ООО', CompanyType.ooo],
  ],

  [Country.GE]: [
    ['ИП', CompanyType.ip],
    ['ООО', CompanyType.ooo],
  ],

  [Country.TJ]: [
    ['ИП', CompanyType.ip],
    ['ООО', CompanyType.ooo],
  ],
  [Country.TM]: [
    ['ИП', CompanyType.ip],
    ['ООО', CompanyType.ooo],
  ],
}

export const countryInnValue = {
  [Country.KZ]: 'ИИН/БИН',
  [Country.AM]: 'ИНН',
  [Country.RU]: 'ИНН',
  [Country.UZ]: {
    [CompanyType.ip]: 'ПИНФЛ',
    [CompanyType.ooo]: 'ИНН',
  },
  [Country.BY]: 'УНП',
  [Country.KG]: 'ИНН',
  [Country.GE]: 'ИНН',
  [Country.TJ]: 'ИНН',
  [Country.TM]: 'ИНН',
}

export const companyTypeName = {
  [CompanyType.ip]: 'Название организации',
  [CompanyType.ooo]: 'Название компании',
}

export const accountDetails = {
  [Country.RU]: {
    bik: 9,
    payAccount: 20,
    corAccount: 20,
    inn: {
      [CompanyType.ip]: 12,
      [CompanyType.ooo]: 10,
    },
  },

  [Country.AM]: {
    inn: 8,
    payAccount: [10, 16],
    bik: [8, 11],
  },

  [Country.KZ]: {
    inn: 12,
    bik: [8, 11],
    payAccount: 20,
  },

  [Country.BY]: {
    inn: 9,
    bik: [8, 11],
    payAccount: 28,
    gln: 13,
  },

  [Country.UZ]: {
    inn: [9, 14],
    bik: 5,
    payAccount: 20,
  },

  [Country.KG]: {
    inn: 14,
    payAccount: 16,
    bik: 6,
  },

  [Country.GE]: {
    inn: 14,
    bik: [8, 11],
    payAccount: 22,
  },

  [Country.TJ]: {
    inn: 9,
    payAccount: 20,
    bik: 9,
  },

  [Country.TM]: {
    inn: 9,
    payAccount: 20,
    bik: 9,
  },
}

export enum DaDataOrderLoadProp {
  bik = 'bik',
  companyName = 'companyName',
}

export const genderOptions = [
  { value: GENDER.MALE, label: 'МУЖ' },
  { value: GENDER.FEMALE, label: 'ЖЕН' },
]

export enum PassportPhotos {
  firtsPageWithPassportPhoto,
  secondPageWithPassportPhoto,
  firstPagePassportPhoto,
  secondPagePassportPhoto,
}
